import React from 'react';
import { Alert } from '@components/Alerts/Alert/Alert';
import { NotificationTypeEnum } from '@interfaces/SurgeryRequest/NotificationTypeEnum';
import { NotificationAlertProps } from './NotificationAlertProps';
import { UnscheduledAlertBody } from './UnscheduledAlertBody/UnscheduledAlertBody';
import { PendingCancellationAlertBody } from './PendingCancellationAlertBody/PendingCancellationAlertBody';
import { CancelledAlertBody } from './CancelledAlertBody/CancelledAlertBody';
import DataConflictAlertBody from './DataConflictAlertBody/DataConflictAlertBody';
import UpdatedDateAlertBody from './UpdatedDateAlertBody/UpdatedDateAlertBody';
import { HospitalRoles, OfficeRoles } from '@interfaces/UserProfile/UserRoleEnum';
import theme from '@theme/theme';

export const NotificationAlert = (notificationProps: NotificationAlertProps) => {
	switch (notificationProps.notification.type) {
	case NotificationTypeEnum.WARNING:
		return <Alert
			data-section="revisionAlert"
			chipColor="error"
			headerColor={`${theme.palette.error[50]}`}
			chipText={NotificationTypeEnum.WARNING.toLowerCase()}
			headerText={notificationProps.notification.title}
			body={<UnscheduledAlertBody description={notificationProps.notification.description} />}
		/>;
	case NotificationTypeEnum.PENDING_CANCELLED:
		return <Alert
			data-section="revisionAlert"
			chipColor="error"
			headerColor={`${theme.palette.error[50]}`}
			chipText={NotificationTypeEnum.WARNING.toLowerCase()}
			headerText={notificationProps.notification.title}
			body={<PendingCancellationAlertBody/>}
		/>;
	case NotificationTypeEnum.CANCELLED:
		return <Alert
			data-section="revisionAlert"
			headerColor={`${theme.palette.grey[200]}`}
			headerText={notificationProps.notification.title}
			body={<CancelledAlertBody/>}
		/>;
	case NotificationTypeEnum.EHR_CONFLICT:
		return <Alert
			data-section="revisionAlert"
			chipColor="error"
			headerColor={`${theme.palette.error[50]}`}
			chipText={NotificationTypeEnum.WARNING.toLowerCase()}
			headerText="Case has data conflicts with the EHR."
			body={<DataConflictAlertBody />}
			showForRoles={HospitalRoles}
		/>
	case NotificationTypeEnum.UPDATED_DATE:
		return <Alert
			data-section="revisionAlert"
			chipColor="error"
			headerColor={`${theme.palette.error[50]}`}
			chipText={NotificationTypeEnum.WARNING.toLowerCase()}
			headerText="Case date has been updated."
			body={<UpdatedDateAlertBody revision={notificationProps.notification}/>}
			showForRoles={OfficeRoles}
		/>;
	default:
		return null;
	}
};
